import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalShow'
})
export class DecimalShowPipe implements PipeTransform {

  readonly DEFAULT_PRECISION: number = 1;

  transform(value: number, ...args: number[]): string {
    const precisionShow = args[0] || this.DEFAULT_PRECISION;
    if (!value) return '';
    return this.truncate(value, precisionShow);
  }

  truncate(numToBeTruncated: number, numOfDecimals: number) {
    const numberTruncated = numToBeTruncated.toString();
    const pointIndex = numberTruncated.indexOf('.');
    return numberTruncated.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined);
  }

}
